import { Route, Routes } from 'react-router-dom';
import {
  LANGUAGE_REDIRECT_KEY,
  LanguageRedirectGeneric,
} from '../wards/common/languageRedirect/LanguageRedirectGeneric';
import React from 'react';
import ScreensFallback, { NOT_FOUND_PATH } from './ScreensFallback';
import { useAlertStore } from '../common/alert/AlertStore';
import { APIProvider } from '@vis.gl/react-google-maps';

type BuildEnv = 'er' | 'wa' | 'wf' | 'all' | undefined;
const env = process.env.REACT_APP_BUILD_NAME as BuildEnv;
const erRoutePath = env === 'er' ? '/*' : '/er/*';
const waRoutePath = env === 'wa' ? '/*' : '/wa/*';
const wfRoutePath = env === 'wf' ? '/*' : '/wf/*';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const lazyNamed = <T extends React.ComponentType<any>>(loader: () => Promise<any>, name: string) =>
  React.lazy(() => loader().then((m) => ({ default: m[name] as T })));

const ErRouter = lazyNamed(() => import('../eris/router/ErRouter'), 'ErRouter');
const WaRouter = lazyNamed(() => import('../wards/router/WaRouter'), 'WaRouter');
const WfRouter = lazyNamed(() => import('../wf/router/WfRouter'), 'WfRouter');

function App() {
  const { content } = useAlertStore();
  return (
    <>
      <Routes>
        {(env === 'er' || env === 'all') && <Route path={erRoutePath} element={<ErRouter />} />}
        {(env === 'wa' || env === 'all') && (
          <Route
            path={waRoutePath}
            element={
              <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY!}>
                <WaRouter />
              </APIProvider>
            }
          />
        )}
        {(env === 'wf' || env === 'all') && (
          <Route
            path={wfRoutePath}
            element={
              <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY!}>
                <WfRouter />
              </APIProvider>
            }
          />
        )}
        <Route
          key={`${LANGUAGE_REDIRECT_KEY}-ja`}
          path="/ja/*"
          element={<LanguageRedirectGeneric forcedLanguage="ja" />}
        />
        <Route
          key={`${LANGUAGE_REDIRECT_KEY}-en`}
          path="/en/*"
          element={<LanguageRedirectGeneric forcedLanguage="en" />}
        />
        <Route
          key={LANGUAGE_REDIRECT_KEY}
          path="/:app/:page/:lng"
          element={<LanguageRedirectGeneric />}
        />

        {/** Default fallback to login routes and if user is already authenticated he is redirected to /main or /login of each app*/}
        <Route path={NOT_FOUND_PATH} element={<>PAGE NOT FOUND</>} />
        <Route path="*" element={<ScreensFallback />} />
      </Routes>
      {content && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50">
          <div className="relative my-10 max-w-screen-2xl overflow-y-auto rounded bg-white p-4 shadow-lg">
            {content}
          </div>
        </div>
      )}
    </>
  );
}

// ts-prune-ignore-next
export default App;
